<template>
  <v-radio
    v-bind="{...$props, ...$attrs}"
    class="w-radio--input"
    v-on="$listeners"
  />
</template>
<script>

import { VRadio } from 'vuetify/lib';

export default {
  name: "WorkRadio",
  inject: ['radioGroup'],
  props: { ...VRadio.options.props },
}
</script>
<style lang="scss">
  .w-radio-group--input{
    legend {
        @include w-p2(true);
    }
    .w-radio--input:not(.v-item--active) {
      .v-icon > svg {
        color: transparent;
        box-shadow: $checkbox-inside-shadow;
        border-radius: 3rem;
        background-color: #fff;
        height: 1.25rem;
        width: 1.25rem;
      }
    }
    .w-radio--input {
      > label {
        @include w-p4
      }
    }
  }
</style>